import {
  AccessibleButtonWrapper,
  DotIndicator,
  IconArrowLeft,
  IconArrowRight,
  typographyRem,
} from '@by-miles/bymiles-styles'
import { DataLayer } from '@by-miles/data-layer'
import React, { useEffect, useState } from 'react'

import { PMBCarouselExplainerStyles } from './PMBCarouselExplainerStyles'
const { h4: H4, h5: H5, paragraphLead: ParagraphLead } = typographyRem

export const PMBCarouselExplainer = () => {
  const [selected, setSelected] = useState<number>(0)

  useEffect(() => {
    const carousel = setTimeout(() => setSelected(selected > 1 ? 0 : selected + 1), 5000)
    return () => clearTimeout(carousel)
  }, [selected])

  const copy = [
    {
      image: <img className="slide-image" src={require('./images/slide-one.png')} alt="slide-one" />,
      title: 'Pay-by-mile is simple.',
      text: 'A fixed cost covers your car while it’s parked.',
    },
    {
      image: <img className="slide-image" src={require('./images/slide-two.png')} alt="slide-two" />,
      title: 'The rest of the cost is based on your mileage.',
      text: 'You’re per-mile rate is fixed, but you’re free to drive as much or as little as you like.',
    },
    {
      image: <img className="slide-image" src={require('./images/slide-three.png')} alt="slide-three" />,
      title: 'You can see the cost of each journey in the app.',
      text: 'So it’s super simple to track your spending.',
    },
  ]

  const { image, title, text } = copy[selected]

  const handleArrowClick = (index: number) => {
    DataLayer.customEvent({
      eventName: `click change carousel slide`,
      section: 'how',
    })
    setSelected(index)
  }

  return (
    <PMBCarouselExplainerStyles>
      <H4 className="component-heading">What is pay-by-mile?</H4>
      <div className="carousel-wrapper">
        <div className="carousel-image-container">{image}</div>
        <div className="carousel-content-container">
          <div className="indicator-wrapper">
            <AccessibleButtonWrapper
              onClick={() => handleArrowClick(selected > 0 ? selected - 1 : 2)}
              icon={<IconArrowLeft />}
            />

            <DotIndicator activeStepIndex={selected} />
            <AccessibleButtonWrapper
              onClick={() => handleArrowClick(selected < 2 ? selected + 1 : 0)}
              icon={<IconArrowRight />}
            />
          </div>
          <H5 className="content-title">{title}</H5>
          <ParagraphLead className="content-text">{text}</ParagraphLead>
        </div>
      </div>
    </PMBCarouselExplainerStyles>
  )
}
